/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConnectionRow } from './connectionRow';

/**
 * One chunk of an upload. ``replace`` on the first chunk drops the previous upload.
 */
export interface UploadConnectionsRequest {
  /**
     * @minItems 1
     * @maxItems 5000
     */
  rows: ConnectionRow[];
  replace?: boolean;
}
